
import { defineComponent, PropType } from 'vue'
import { PackageType, RepositoryPackage } from '~/types/types'

export interface PackagesPropT {
  packages: RepositoryPackage[]
  currentPage: number
  hasNextPage: boolean
  totalCount: number
  perPageCount: number
}

export default defineComponent({
  name: 'PackageList',
  props: {
    title: {
      type: String,
      required: true
    },
    item: {
      type: Object as PropType<PackagesPropT>,
      required: true
    },
    subcategory: {
      type: String as PropType<PackageType>,
      required: true
    },
    itemsToShow: {
      type: Number,
      default: 10
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      PackageType
    }
  },
  computed: {
    allRoute() {
      const { provider, owner, repo, target } = this.$route.params
      return {
        name: 'provider-owner-repo-dependencies-target-packages',
        params: { provider, owner, repo, target },
        query: { pkgType: this.subcategory }
      }
    },
    packagesN() {
      return this.item.packages.slice(0, this.itemsToShow)
    },
    startItemNumber(): number {
      const n = this.item.currentPage * this.item.perPageCount - (this.item.perPageCount - 1)
      return n > 0 ? n : 0
    },
    endItemNumber() {
      const n = this.item.currentPage * this.item.perPageCount
      return n > this.item.totalCount ? this.item.totalCount : n
    }
  }
})
